import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { TIME_VALUES } from '~/Constants/Date.constants';
import { PROVIDER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { useProvider } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import {
  IStudioCategoryRequest,
  IStudioCategoryResponse,
} from '~/Models/DTO/StudioCategories.model';

export const useRequestCategories = (defaultQuery?: { [name: string]: any }) => {
  // hooks
  const { currentProvider } = useProvider();
  const { t } = useTranslation();

  return useQuery<IStudioCategoryResponse[], IErrorResponse>(
    [REQUEST_ACTIONS.STUDIO_CATEGORIES, defaultQuery, currentProvider?.organisationId],
    async () => {
      const result = await requestReactQuery<IStudioCategoryRequest>({
        url: PROVIDER_SERVICE_URLS.STUDIO_CATEGORIES,
        config: { method: 'GET' },
      });

      return result.providerCategories.map((item) => ({
        value: item.id,
        label: t(`search.categories.${item.id}`),
      }));
    },
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
      refetchInterval: TIME_VALUES.HOUR,
      initialData: [],
    },
  );
};
